var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("portal-mobile", { attrs: { "portal-to": "mobile-b2b-select" } }, [
    _c(
      "div",
      {
        class: {
          "price-switch--inactive": !_vm.isActive,
          "d-none": _vm.noSwitchCountry
        }
      },
      [
        _c(
          "a",
          {
            attrs: {
              id: "js--price-switch",
              "data-toggle": "dropdown",
              href: "#",
              "aria-expanded": "false",
              "aria-haspopup": "true",
              "data-boundary": "viewport"
            }
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.priceType.active) + "\n            "
            ),
            _vm.isActive
              ? _c("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg" } }, [
                  _c("use", {
                    attrs: {
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xlink:href": "#svg-caret"
                    }
                  })
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.isActive
          ? _c(
              "div",
              {
                staticClass: "dropdown-menu header__dropdown",
                attrs: { "aria-labelledby": "js--price-switch" }
              },
              [
                _c("ul", { staticClass: "list-unstyled" }, [
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.toggleType(
                              $event,
                              _vm.priceType.inactive.type
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.priceType.inactive.label) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }